import { useEffect, useState } from "react";
import BaseModal from "../../../components/BaseModal";
import "../../../assets/css/activeLoans.css";

export default function ActiveLoans() {
  const [loans, setLoans] = useState<any[]>([]);
  const [search, setSearch] = useState("");
  const [status, setStatus] = useState("ALL");
  const [loading, setLoading] = useState(false);
  const [selectedLoan, setSelectedLoan] = useState<any | null>(null);


  const [editLoanModal, setEditLoanModal] = useState(false);

  const [auditHistory, setAuditHistory] = useState<any[]>([]);
const [auditModal, setAuditModal] = useState(false);

const [editForm, setEditForm] = useState({
  first_name: "",
  last_name: "",
  email: "",
  phone: "",
  other_phone: "",
  bvn: "",
  nin: "",
  ippis_number: "",
  gender: "",
  dob: "",
  address: "",
  state_of_origin: "",
  employer: "",
  bank_name: "",
  account_number: "",
  next_of_kin: "",
  nok_phone: "",
  loan_product: "",
  loan_tenor: "",
  approved_amount: "",
});


const [restructureModal, setRestructureModal] = useState(false);
const [confirmRestructureModal, setConfirmRestructureModal] = useState(false);
const [newMonthlyRepayment, setNewMonthlyRepayment] = useState("");
const [restructuring, setRestructuring] = useState(false);

  const [closeLoanModal, setCloseLoanModal] = useState(false);
const [closingLoan, setClosingLoan] = useState(false);
const [closeReason, setCloseReason] = useState("");

  const [currentPage, setCurrentPage] = useState(1);
  const [itemsPerPage, setItemsPerPage] = useState(10);

  const fetchActiveLoans = async () => {
    try {
      setLoading(true);

      const res = await fetch(
        `${process.env.REACT_APP_API_BASE}/active_loans.php`,
        { credentials: "include" }
      );

      const data = await res.json();

      if (data.success) {
        setLoans(data.loans || []);
      } else {
        setLoans([]);
      }
    } catch (err) {
      console.error("Fetch active loans error:", err);
      setLoans([]);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchActiveLoans();
  }, []);

  useEffect(() => {
    setCurrentPage(1);
  }, [search, status]);

  const filteredLoans = loans.filter((loan) => {
    const q = search.toLowerCase();

    const matchesSearch =
      loan.customer_name?.toLowerCase().includes(q) ||
      loan.loan_account?.toLowerCase().includes(q) ||
      loan.assignment_number?.toLowerCase().includes(q) ||
      loan.product?.toLowerCase().includes(q);

    const matchesStatus =
      status === "ALL" || loan.status?.toUpperCase() === status;

    return matchesSearch && matchesStatus;
  });

  const totalPages = Math.ceil(filteredLoans.length / itemsPerPage) || 1;

  const paginatedLoans = filteredLoans.slice(
    (currentPage - 1) * itemsPerPage,
    currentPage * itemsPerPage
  );

  const totalOutstanding = loans.reduce(
    (sum, loan) => sum + Number(loan.outstanding_balance || 0),
    0
  );

const totalDisbursed = loans.reduce(
  (sum, loan) =>
    sum + Number(loan.approved_amount || loan.loan_amount || 0),
  0
);

  const overdueLoans = loans.filter(
    (loan) => loan.status?.toUpperCase() === "OVERDUE"
  ).length;

const formatMoney = (amount: number) =>
  `₦${Number(amount || 0).toLocaleString("en-NG", {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  })}`;


const formatNumberInput = (value: string) => {
  const clean = value.replace(/,/g, "");

  if (clean === "") return "";

  const parts = clean.split(".");
  const whole = parts[0];
  const decimal = parts[1] !== undefined ? "." + parts[1].slice(0, 2) : "";

  return Number(whole || 0).toLocaleString("en-NG") + decimal;
};

const parseMoneyInput = (value: string) => {
  return Number(value.replace(/,/g, ""));
};


  const modalTotalSchedule =
    selectedLoan?.schedule?.reduce(
      (sum: number, row: any) => sum + Number(row.amount || 0),
      0
    ) || 0;

  const modalTotalPaid =
    selectedLoan?.schedule?.reduce(
      (sum: number, row: any) =>
        sum + (row.paid ? Number(row.amount || 0) : 0),
      0
    ) || 0;

  const modalBalance = modalTotalSchedule - modalTotalPaid;

const handleCloseLoan = async () => {
  if (!selectedLoan) return;

  if (!closeReason.trim()) {
  alert("Please enter a reason for closing this loan.");
  return;
}

  try {
    setClosingLoan(true);

    const response = await fetch(
     `${process.env.REACT_APP_API_BASE}/loans/close_loan.php`,
      {
        method: "POST",
        credentials: "include",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          loan_id: selectedLoan.id,
          reason: closeReason,
        }),
      }
    );

    const data = await response.json();

    if (!response.ok || !data.success) {
      throw new Error(data.message || "Failed to close loan");
    }

    setCloseLoanModal(false);
    setSelectedLoan(null);
    setCloseReason("");

    fetchActiveLoans();
  } catch (err: any) {
    console.error(err);
    alert(err.message || "Failed to close loan");
  } finally {
    setClosingLoan(false);
  }
};


const handleRestructureSchedule = async () => {
  if (!selectedLoan) return;

  const amount = parseMoneyInput(newMonthlyRepayment);

  if (!amount || amount <= 0) {
    alert("Please enter a valid monthly repayment amount.");
    return;
  }

  try {
    setRestructuring(true);

    const response = await fetch(
      `${process.env.REACT_APP_API_BASE}/loans/restructure_schedule.php`,
      {
        method: "POST",
        credentials: "include",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          loan_id: selectedLoan.id,
          monthly_repayment: amount,
        }),
      }
    );

    const data = await response.json();

    if (!response.ok || !data.success) {
      throw new Error(data.message || "Failed to restructure schedule");
    }

    setConfirmRestructureModal(false);
    setRestructureModal(false);
    setNewMonthlyRepayment("");
    setSelectedLoan(null);

    fetchActiveLoans();
  } catch (err: any) {
    console.error(err);
    alert(err.message || "Failed to restructure schedule");
  } finally {
    setRestructuring(false);
  }
};


const handleUpdateLoan = async () => {
  if (!selectedLoan) return;

  try {
    const response = await fetch(
      `${process.env.REACT_APP_API_BASE}/loans/update_active_loan.php`,
      {
        method: "POST",
        credentials: "include",
        headers: {
          "Content-Type": "application/json",
        },
     body: JSON.stringify({
  loan_id: selectedLoan.id,

  first_name: editForm.first_name,
  last_name: editForm.last_name,

  phone: editForm.phone,
  other_phone: editForm.other_phone,

  email: editForm.email,

  bvn: editForm.bvn,
  nin: editForm.nin,

  ippis_number: editForm.ippis_number,

  gender: editForm.gender,
  dob: editForm.dob,

  address: editForm.address,
  state_of_origin: editForm.state_of_origin,

  employer: editForm.employer,

  bank_name: editForm.bank_name,
  account_number: editForm.account_number,

  next_of_kin: editForm.next_of_kin,
  nok_phone: editForm.nok_phone,

  loan_product: editForm.loan_product,
  loan_tenor: editForm.loan_tenor,

  approved_amount: editForm.approved_amount,
}),

      }
    );

    const data = await response.json();

    if (!response.ok || !data.success) {
      throw new Error(data.message || "Failed to update loan");
    }

   alert("Loan updated successfully");

setEditLoanModal(false);

await fetchAuditHistory(selectedLoan.id);

fetchActiveLoans();
  } catch (err: any) {
    alert(err.message || "Failed to update loan");
  }
};

const fetchAuditHistory = async (loanId: number) => {
  try {
    const response = await fetch(
      `${process.env.REACT_APP_API_BASE}/loans/get_loan_audit.php?loan_id=${loanId}`,
      {
        credentials: "include",
      }
    );

    const data = await response.json();

    if (data.success) {
      setAuditHistory(data.history || []);
    }
  } catch (err) {
    console.error(err);
  }
};

  return (
    <div className="active-loans-page">
      <div className="active-loans-header">
        <div>
          <span className="active-loans-badge">Loan Operations</span>
          <h2>Active Loans</h2>
          <p>Monitor all active loan accounts, repayments, balances and status.</p>
        </div>

        <button className="active-loans-refresh-btn" onClick={fetchActiveLoans}>
          <i className="fa fa-refresh" /> Refresh
        </button>
      </div>

      <div className="active-loans-summary-grid">
        <SummaryCard icon="fa fa-folder-open" title="Total Active Loans" value={loans.length} color="blue" />
        <SummaryCard icon="fa fa-chart-line" title="Total Outstanding" value={formatMoney(totalOutstanding)} color="purple" />
        <SummaryCard icon="fa fa-wallet" title="Total Disbursed" value={formatMoney(totalDisbursed)} color="green" />
        <SummaryCard icon="fa fa-exclamation-triangle" title="Overdue Loans" value={overdueLoans} color="red" />
      </div>

      <div className="active-loans-card">
        <div className="active-loans-toolbar">
          <div className="active-search-box">
            <i className="fa fa-search" />
            <input
              type="text"
              placeholder="Search customer, loan account, product..."
              value={search}
              onChange={(e) => setSearch(e.target.value)}
            />
          </div>

          <select
            className="active-filter"
            value={status}
            onChange={(e) => setStatus(e.target.value)}
          >
            <option value="ALL">All Status</option>
            <option value="ACTIVE">Active</option>
            <option value="OVERDUE">Overdue</option>
            <option value="CLOSED">Closed</option>
          </select>
        </div>

        <div className="active-pagination active-pagination-top">
          <span>
            Showing{" "}
            {filteredLoans.length === 0
              ? 0
              : (currentPage - 1) * itemsPerPage + 1}
            –{Math.min(currentPage * itemsPerPage, filteredLoans.length)} of{" "}
            {filteredLoans.length}
          </span>

          <div className="active-pagination-controls">
            <select
              value={itemsPerPage}
              onChange={(e) => {
                setItemsPerPage(Number(e.target.value));
                setCurrentPage(1);
              }}
            >
              <option value={10}>10 / page</option>
              <option value={25}>25 / page</option>
              <option value={50}>50 / page</option>
            </select>

            <button
              disabled={currentPage === 1}
              onClick={() => setCurrentPage((p) => p - 1)}
            >
              ‹
            </button>

            <strong>{currentPage}</strong>

            <button
              disabled={currentPage >= totalPages}
              onClick={() => setCurrentPage((p) => p + 1)}
            >
              ›
            </button>
          </div>
        </div>

        <div className="table-responsive">
          <table className="active-loans-table">
            <thead>
              <tr>
                <th>S/N</th>
                <th>Loan Account</th>
                <th>Customer</th>
                <th>Product</th>
                <th>Amount</th>
                <th>Outstanding</th>
                <th>Repayment</th>
                <th>Next Due Date</th>
                <th>Status</th>
                <th>Action</th>
              </tr>
            </thead>

            <tbody>
              {loading ? (
                <tr>
                  <td colSpan={10} className="active-empty">
                    Loading active loans...
                  </td>
                </tr>
              ) : filteredLoans.length === 0 ? (
                <tr>
                  <td colSpan={10} className="active-empty">
                    <i className="fa fa-folder-open" />
                    <p>No active loans found</p>
                    <small>Loan accounts will appear here once available.</small>
                  </td>
                </tr>
              ) : (
                paginatedLoans.map((loan, index) => (
                  <tr key={loan.id}>
                    <td>{(currentPage - 1) * itemsPerPage + index + 1}</td>
                    <td>{loan.loan_account || "-"}</td>
                    <td>
                      <strong>{loan.customer_name || "-"}</strong>
                      <span>{loan.assignment_number || "-"}</span>
                    </td>
                    <td>{loan.product || "-"}</td>
                   <td>
  {formatMoney(
    loan.approved_amount || loan.loan_amount
  )}
</td>
                    <td>{formatMoney(loan.outstanding_balance)}</td>
                    <td>{formatMoney(loan.monthly_repayment)}</td>
                    <td>{loan.next_due_date || "-"}</td>
                    <td>
                      <span className={`active-status ${loan.status?.toLowerCase()}`}>
                        {loan.status || "-"}
                      </span>
                    </td>
                    <td>
                      <button
                        className="active-view-btn"
                        onClick={() => setSelectedLoan(loan)}
                      >
                        View
                      </button>
                    </td>
                  </tr>
                ))
              )}
            </tbody>
          </table>
        </div>
      </div>

      <BaseModal
        isOpen={!!selectedLoan}
        title="Active Loan Details"
        size="lg"
        onClose={() => setSelectedLoan(null)}
       footer={
  <div className="modal-actions">

    {selectedLoan?.status?.toUpperCase() !== "CLOSED" && (
  <button
    className="btn-outline"
    onClick={() => {
      setNewMonthlyRepayment("");
      setRestructureModal(true);
    }}
  >
    Restructure Schedule
  </button>
)}


<button
  className="btn-outline"
  onClick={() => {
setEditForm({
  first_name: selectedLoan.first_name || "",
  last_name: selectedLoan.last_name || "",
  email: selectedLoan.email || "",
  phone: selectedLoan.phone || "",
  other_phone: selectedLoan.other_phone || "",
  bvn: selectedLoan.bvn || "",
  nin: selectedLoan.nin || "",
  ippis_number: selectedLoan.ippis_number || "",
  gender: selectedLoan.gender || "",
  dob: selectedLoan.dob || "",
  address: selectedLoan.address || "",
  state_of_origin: selectedLoan.state_of_origin || "",
  employer: selectedLoan.employer || "",
  bank_name: selectedLoan.bank_name || "",
  account_number: selectedLoan.account_number || "",
  next_of_kin: selectedLoan.next_of_kin || "",
  nok_phone: selectedLoan.nok_phone || "",
  loan_product: selectedLoan.loan_product || "",
  loan_tenor: selectedLoan.loan_tenor || "",
  approved_amount: selectedLoan.approved_amount || "",
});

    setEditLoanModal(true);
  }}
>
  Correct Loan Details
</button>



<button
  className="btn-outline"
  onClick={() => {
    fetchAuditHistory(selectedLoan.id);
    setAuditModal(true);
  }}
>
  Audit History
</button>



    {selectedLoan?.status?.toUpperCase() !== "CLOSED" && (
      <button
        className="btn-danger"
        onClick={() => setCloseLoanModal(true)}
      >
        Close Loan
      </button>
    )}

    <button
      className="active-view-btn"
      onClick={() => setSelectedLoan(null)}
    >
      Close
    </button>
  </div>
}
      >
        {selectedLoan && (
          <div className="loan-detail-modal">
            <div className="loan-detail-grid">
              <Detail label="Customer Name" value={selectedLoan.customer_name} />
              <Detail label="Loan Account" value={selectedLoan.loan_account} />
              <Detail label="Assignment Number" value={selectedLoan.assignment_number} />
              <Detail label="Product" value={selectedLoan.product} />
              <Detail label="Phone" value={selectedLoan.phone} />
              <Detail label="Email" value={selectedLoan.email} />
              <Detail label="Tenor" value={selectedLoan.tenor} />
              <Detail label="Disbursed Date" value={selectedLoan.disbursed_date} />
            </div>

            <div className="loan-modal-summary">
              <div>
                <span>Loan Amount</span>
               <strong>
  {formatMoney(
    selectedLoan.approved_amount || selectedLoan.loan_amount
  )}
</strong>
              </div>

              <div>
                <span>Total Schedule</span>
                <strong>{formatMoney(modalTotalSchedule)}</strong>
              </div>

              <div>
                <span>Total Paid</span>
                <strong className="text-success">{formatMoney(modalTotalPaid)}</strong>
              </div>

              <div>
                <span>Balance</span>
                <strong className="text-danger">{formatMoney(modalBalance)}</strong>
              </div>
            </div>

            <h4 className="schedule-title">Repayment Schedule</h4>

            <div className="table-responsive">
              <table className="active-loans-table">
                <thead>
                  <tr>
                    <th>#</th>
                    <th>Month</th>
                    <th>Due Date</th>
                    <th>Amount</th>
                    <th>Payment Status</th>
                  </tr>
                </thead>

                <tbody>
                 {[...(selectedLoan.schedule || [])]
  .sort((a: any, b: any) => {
  return new Date(a.due_date).getTime() - new Date(b.due_date).getTime();
})
  .map((row: any, index: number) => (
                    <tr key={index}>
                      <td>{index + 1}</td>
                      <td>{row.month}</td>
                      <td>{row.due_date}</td>
                      <td>{formatMoney(row.amount)}</td>
                      <td>
                      <span
  className={
    row.payment_status === "paid"
      ? "repayment-paid-badge"
      : row.payment_status === "partial"
      ? "repayment-partial-badge"
      : "repayment-unpaid-badge"
  }
>
  {row.payment_status === "paid"
    ? "Paid"
    : row.payment_status === "partial"
    ? "Partially Paid"
    : "Unpaid"}
</span>
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          </div>
        )}
      </BaseModal>

      <BaseModal
  isOpen={closeLoanModal}
  title="Close Loan"
  size="sm"
  onClose={() => setCloseLoanModal(false)}
>
  <div className="approve-section">
    <div className="approve-input-group">
      <label>Reason for closing loan</label>

      <textarea
        className="approve-input"
        rows={4}
        value={closeReason}
        onChange={(e) => setCloseReason(e.target.value)}
        placeholder="Enter reason..."
      />
    </div>
    

    <div className="modal-actions">
      <button
        className="btn-outline"
        onClick={() => setCloseLoanModal(false)}
      >
        Cancel
      </button>

      <button
        className="btn-danger"
        disabled={closingLoan}
        onClick={handleCloseLoan}
      >
        {closingLoan ? "Closing..." : "Confirm Close"}
      </button>
    </div>
  </div>
</BaseModal>



<BaseModal
  isOpen={restructureModal}
  title="Restructure Repayment Schedule"
  size="sm"
  onClose={() => setRestructureModal(false)}
>
  <div className="approve-section">
    <div className="approve-input-group">
      <label>New Monthly Repayment</label>

     <input
  className="approve-input"
  type="text"
  inputMode="decimal"
  value={newMonthlyRepayment}
  onChange={(e) => {
    const value = e.target.value.replace(/[^\d.]/g, "");
    setNewMonthlyRepayment(formatNumberInput(value));
  }}
  placeholder="Enter new monthly repayment e.g. 18,083.33"
/>
    </div>

    <div className="modal-actions">
      <button
        className="btn-outline"
        onClick={() => setRestructureModal(false)}
      >
        Cancel
      </button>

    <button
  className="active-view-btn"
  onClick={() => {
   const amount = parseMoneyInput(newMonthlyRepayment);

    if (!amount || amount <= 0) {
      alert("Please enter a valid monthly repayment amount.");
      return;
    }

    setConfirmRestructureModal(true);
  }}
>
  Continue
</button>
    </div>
  </div>
</BaseModal>

<BaseModal
  isOpen={confirmRestructureModal}
  title="Confirm Schedule Restructure"
  size="sm"
  onClose={() => setConfirmRestructureModal(false)}
>
  <div className="approve-section">
    <p>
      This will update the repayment schedule for{" "}
      <strong>{selectedLoan?.customer_name}</strong>.
    </p>

    <p>
      New monthly repayment:{" "}
     <strong>{formatMoney(parseMoneyInput(newMonthlyRepayment))}</strong>
    </p>

    <div className="modal-actions">
      <button
        className="btn-outline"
        onClick={() => setConfirmRestructureModal(false)}
      >
        Cancel
      </button>

      <button
        className="btn-danger"
        disabled={restructuring}
        onClick={handleRestructureSchedule}
      >
        {restructuring ? "Saving..." : "Confirm Save"}
      </button>
    </div>
  </div>
</BaseModal>


<BaseModal
  isOpen={editLoanModal}
  title="Correct Loan Details"
  size="lg"
  onClose={() => setEditLoanModal(false)}
>
  <div className="approve-section">

    <div className="loan-edit-grid">

      <div className="approve-input-group">
        <label>First Name</label>
        <input
          className="approve-input"
          value={editForm.first_name}
          onChange={(e) =>
            setEditForm({
              ...editForm,
              first_name: e.target.value,
            })
          }
        />
      </div>

      <div className="approve-input-group">
        <label>Last Name</label>
        <input
          className="approve-input"
          value={editForm.last_name}
          onChange={(e) =>
            setEditForm({
              ...editForm,
              last_name: e.target.value,
            })
          }
        />
      </div>

      <div className="approve-input-group">
        <label>Phone</label>
        <input
          className="approve-input"
          value={editForm.phone}
          onChange={(e) =>
            setEditForm({
              ...editForm,
              phone: e.target.value,
            })
          }
        />
      </div>

      <div className="approve-input-group">
        <label>Other Phone</label>
        <input
          className="approve-input"
          value={editForm.other_phone}
          onChange={(e) =>
            setEditForm({
              ...editForm,
              other_phone: e.target.value,
            })
          }
        />
      </div>

      <div className="approve-input-group">
        <label>Email</label>
        <input
          className="approve-input"
          value={editForm.email}
          onChange={(e) =>
            setEditForm({
              ...editForm,
              email: e.target.value,
            })
          }
        />
      </div>

      <div className="approve-input-group">
        <label>BVN</label>
        <input
          className="approve-input"
          value={editForm.bvn}
          onChange={(e) =>
            setEditForm({
              ...editForm,
              bvn: e.target.value,
            })
          }
        />
      </div>

      <div className="approve-input-group">
        <label>NIN</label>
        <input
          className="approve-input"
          value={editForm.nin}
          onChange={(e) =>
            setEditForm({
              ...editForm,
              nin: e.target.value,
            })
          }
        />
      </div>

      <div className="approve-input-group">
        <label>IPPIS Number</label>
        <input
          className="approve-input"
          value={editForm.ippis_number}
          onChange={(e) =>
            setEditForm({
              ...editForm,
              ippis_number: e.target.value,
            })
          }
        />
      </div>

      <div className="approve-input-group">
        <label>Gender</label>
        <input
          className="approve-input"
          value={editForm.gender}
          onChange={(e) =>
            setEditForm({
              ...editForm,
              gender: e.target.value,
            })
          }
        />
      </div>

      <div className="approve-input-group">
        <label>Date Of Birth</label>
        <input
          className="approve-input"
          value={editForm.dob}
          onChange={(e) =>
            setEditForm({
              ...editForm,
              dob: e.target.value,
            })
          }
        />
      </div>

      <div className="approve-input-group">
        <label>Address</label>
        <input
          className="approve-input"
          value={editForm.address}
          onChange={(e) =>
            setEditForm({
              ...editForm,
              address: e.target.value,
            })
          }
        />
      </div>

      <div className="approve-input-group">
        <label>State Of Origin</label>
        <input
          className="approve-input"
          value={editForm.state_of_origin}
          onChange={(e) =>
            setEditForm({
              ...editForm,
              state_of_origin: e.target.value,
            })
          }
        />
      </div>

      <div className="approve-input-group">
        <label>Employer</label>
        <input
          className="approve-input"
          value={editForm.employer}
          onChange={(e) =>
            setEditForm({
              ...editForm,
              employer: e.target.value,
            })
          }
        />
      </div>

      <div className="approve-input-group">
        <label>Bank Name</label>
        <input
          className="approve-input"
          value={editForm.bank_name}
          onChange={(e) =>
            setEditForm({
              ...editForm,
              bank_name: e.target.value,
            })
          }
        />
      </div>

      <div className="approve-input-group">
        <label>Account Number</label>
        <input
          className="approve-input"
          value={editForm.account_number}
          onChange={(e) =>
            setEditForm({
              ...editForm,
              account_number: e.target.value,
            })
          }
        />
      </div>

      <div className="approve-input-group">
        <label>Next Of Kin</label>
        <input
          className="approve-input"
          value={editForm.next_of_kin}
          onChange={(e) =>
            setEditForm({
              ...editForm,
              next_of_kin: e.target.value,
            })
          }
        />
      </div>

      <div className="approve-input-group">
        <label>Next Of Kin Phone</label>
        <input
          className="approve-input"
          value={editForm.nok_phone}
          onChange={(e) =>
            setEditForm({
              ...editForm,
              nok_phone: e.target.value,
            })
          }
        />
      </div>

      <div className="approve-input-group">
        <label>Loan Product</label>
        <input
          className="approve-input"
          value={editForm.loan_product}
          onChange={(e) =>
            setEditForm({
              ...editForm,
              loan_product: e.target.value,
            })
          }
        />
      </div>

      <div className="approve-input-group">
        <label>Loan Tenor</label>
        <input
          className="approve-input"
          value={editForm.loan_tenor}
          onChange={(e) =>
            setEditForm({
              ...editForm,
              loan_tenor: e.target.value,
            })
          }
        />
      </div>

      <div className="approve-input-group">
        <label>Approved Amount</label>
        <input
          className="approve-input"
          value={editForm.approved_amount}
          onChange={(e) =>
            setEditForm({
              ...editForm,
              approved_amount: e.target.value,
            })
          }
        />
      </div>

    </div>

    <div className="modal-actions">
      <button
        className="btn-outline"
        onClick={() => setEditLoanModal(false)}
      >
        Cancel
      </button>

      <button
        className="active-view-btn"
        onClick={handleUpdateLoan}
      >
        Save Changes
      </button>
    </div>

  </div>
</BaseModal>




<BaseModal
  isOpen={auditModal}
  title="Loan Audit History"
  size="lg"
  onClose={() => setAuditModal(false)}
>
  <div className="table-responsive">
    <table className="active-loans-table">
      <thead>
        <tr>
          <th>Date</th>
          <th>Field</th>
          <th>Old Value</th>
          <th>New Value</th>
          <th>Changed By</th>
        </tr>
      </thead>

      <tbody>
        {auditHistory.length === 0 ? (
          <tr>
            <td colSpan={5}>
              No audit records found
            </td>
          </tr>
        ) : (
          auditHistory.map((row, index) => (
            <tr key={index}>
              <td>{row.created_at}</td>
              <td>{row.field_name}</td>
              <td>{row.old_value}</td>
              <td>{row.new_value}</td>
              <td>{row.changed_by_name}</td>
            </tr>
          ))
        )}
      </tbody>
    </table>
  </div>
</BaseModal>


    </div>
  );
}

function SummaryCard({
  icon,
  title,
  value,
  color,
}: {
  icon: string;
  title: string;
  value: string | number;
  color: "blue" | "purple" | "green" | "orange" | "red";
}) {
  return (
    <div className={`active-summary-card ${color}`}>
      <div className="active-summary-icon">
        <i className={icon}></i>
      </div>

      <div>
        <span>{title}</span>
        <h3>{value}</h3>
      </div>
    </div>
  );
}

function Detail({ label, value }: { label: string; value: any }) {
  return (
    <div className="loan-detail-item">
      <span>{label}</span>
      <strong>{value || "-"}</strong>
    </div>
  );
}